// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selectOptions-selectOptionsWrapper-H9S {\n  flex-basis: 47%;\n}\n\n.selectOptions-selectOptionsImage-psG {\n  height: auto;\n  width: 113px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectOptionsWrapper": "selectOptions-selectOptionsWrapper-H9S bg-snowbound items-center flex",
	"selectOptionsImage": "selectOptions-selectOptionsImage-psG"
};
export default ___CSS_LOADER_EXPORT___;
